import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular';
import { ClientInfo } from '../../model/clientInfo.model';

@Component({
  selector: 'app-notes-viewer',
  templateUrl: './notes-viewer.component.html',
  styleUrls: ['./notes-viewer.component.css']
})
export class NotesViewerComponent implements OnInit {

  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  constructor() { }

  notesText: string = "";

  ngOnInit(): void {
  }

  onShowing(e) {

  }

  onHiding(e) {

  }

  public show(title: string, info: ClientInfo, notesText: string) {
    this.popup.title = title + " : " + info.FirstName + " " + info.LastName;
    this.notesText = notesText;
    this.popup.visible = true;
  }
}
